module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('section', {
    staticClass: "main_section",
    class: {
      'pic--1': _vm.slogan === 1, 'pic--2': _vm.slogan === 2
    }
  }, [(_vm.slogan === 1) ? _c('div', {
    staticClass: "slogan"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("來趟小旅行一塊學英語！")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("「遊臺中學英語」提供創新型態的學習服務，透過熱門景點進行影音互動學習。和我們一起快樂玩，輕鬆學，走遍臺中景點，學好旅遊英語，收藏在地旅行的動人回憶。")])]) : _vm._e(), _vm._v(" "), (_vm.slogan === 2) ? _c('div', {
    staticClass: "slogan2"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("遊臺中學英語 APP")]), _vm._v(" "), _c('p', [_vm._v("臺中就是你的英語教室")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sloganPagination text-xs-center"
  }, [_c('v-btn', {
    staticClass: "bg--primary",
    attrs: {
      "small": "",
      "floating": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.sloganClick(1)
      }
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('v-btn', {
    staticClass: "bg--primary",
    attrs: {
      "small": "",
      "floating": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.sloganClick(2)
      }
    }
  }, [_vm._v("2")])], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "pa-5 bg--white",
    attrs: {
      "id": "anchor-1"
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("功能特色")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("四大學習功能讓您邊玩邊學")]), _vm._v(" "), _c('v-row', {
    staticClass: "text-xs-left"
  }, [_c('v-col', {
    attrs: {
      "sm5": "",
      "offset-sm1": "",
      "pa-3": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "xs3": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_video.svg")
    }
  })]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("互動課程")]), _vm._v(" "), _c('p', [_vm._v("包含實用會話、影音簡介、圖解單字與學習任務等學習功能，想知道臺中哪裡好玩，想要身歷其境，現場即時學英語，請立刻下載，讓『遊臺中學英語』 APP 陪你一起暢遊臺中學英語。")])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm5": "",
      "pa-3": ""
    }
  }, [_c('hr', {
    staticClass: "hidden-sm-and-up",
    staticStyle: {
      "margin-bottom": "1.5em"
    }
  }), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "xs3": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_coin.svg")
    }
  })]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("闖關任務 / 金幣兌換")]), _vm._v(" "), _c('p', [_vm._v("每個景點都規劃了英語學習任務，讓學習者從問答中認識景點特色及相關英語，讓你邊玩邊學好英語，答對可獲得金幣，還能兌換禮物哦！")])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm5": "",
      "offset-sm1": ""
    }
  }, [_c('hr', {
    staticStyle: {
      "margin-bottom": "1.5em"
    }
  }), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "xs3": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_location.svg")
    }
  })]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("GPS定位")]), _vm._v(" "), _c('p', [_vm._v("使用 GPS 定位快速找到鄰近的景點，跟著 APP 吃喝玩樂學英語，來趟不一樣的深度臺中之旅。")])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm5": ""
    }
  }, [_c('hr', {
    staticStyle: {
      "margin-bottom": "1.5em"
    }
  }), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "xs3": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_ar.svg")
    }
  })]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("擴增實境")]), _vm._v(" "), _c('p', [_vm._v("採用創新擴增實境 (AR) 技術，進行解鎖任務，連結景點場景，體驗浸潤式的英語學習樂趣。")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "pa-5 bg--primary",
    attrs: {
      "id": "anchor-2"
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("熱門景點")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("最受歡迎的臺中熱門景點大推薦")]), _vm._v(" "), _c('v-row', {
    staticClass: "text-xs-left"
  }, [_c('v-col', {
    attrs: {
      "sm3": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/p_04.png"),
      "width": "100%"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("國立自然科學博物館")]), _vm._v(" "), _c('p', [_vm._v("位於臺灣臺中市北區的公立科學博物館，由科學中心、太空劇場、生命科學廳、人類文化廳、地球環境廳與植物園所共同組成。每年參觀人數居臺灣博物館第二（僅次於故宮），平均三百萬人。")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm3": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/p_03.png"),
      "width": "100%"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("勤美術館")]), _vm._v(" "), _c('p', [_vm._v("由知名建築師陳瑞憲與郭旭原將大樓重新改裝設計。室內植生牆共13,200株植栽，由地下2樓延伸至地上3樓（高達20公尺）；室外植生牆共118,300株，當時為亞洲最大的植生牆。")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm3": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/p_02.png"),
      "width": "100%"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("東海大學")]), _vm._v(" "), _c('p', [_vm._v("東海大學，是一所基督教新教背景綜合大學，座落於臺中市西屯區大肚山山麓，是第一所在臺灣非改制升格設立且現存的私大。東海大學擁有完整規劃的校園，其建築在台灣近代建築具代表性。")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm3": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/p_01.png"),
      "width": "100%"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("逢甲夜市")]), _vm._v(" "), _c('p', [_vm._v("逢甲夜市，位於臺中市西屯區逢甲大學周圍，屬商圈夜市類型。以文華路、福星路為核心的區域，另外延伸走進文華路可達逢甲旗艦夜市，目前是臺灣規模最大的夜市。")])])], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "pa-5 bg--white",
    attrs: {
      "id": "anchor-3"
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("下載方式")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("這麼酷的APP還不快下載")]), _vm._v(" "), _c('v-row', {
    staticClass: "pa-3"
  }, [_c('v-col', {
    attrs: {
      "xs12": "",
      "offset-sm3": "",
      "sm3": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/tw/app/%E9%81%8A%E8%87%BA%E4%B8%AD%E5%AD%B8%E8%8B%B1%E8%AA%9E-%E8%8B%B1%E8%AA%9E%E8%A7%80%E5%85%89%E5%9F%8E/id1173769883?l=zh&mt=8",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_02.png")
    }
  })])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.liveabc.android.gbl4g",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_03.png")
    }
  })])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-3 text-xs-left"
  }, [_c('v-col', {
    attrs: {
      "offset-sm1": "",
      "sm5": ""
    }
  }, [_c('div', {
    staticClass: "ma-4 pb-4",
    staticStyle: {
      "min-height": "9em"
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Step 1 免費註冊")]), _vm._v(" "), _c('p', [_vm._v("下載並開啟『遊臺中學英語』 APP，完成 LiveABC 會員註冊程序，即可免費獲得「國立臺灣美術館」課程，前往景點學習。")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "ma-4 pb-4",
    staticStyle: {
      "min-height": "9em"
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Step 2 進入課程")]), _vm._v(" "), _c('p', [_vm._v("購買悠活30方案或暢遊365方案，進入學習課程。透過 GPS 定位，開啟互動影音課程，體驗浸潤式的英語學習樂趣。")])]), _vm._v(" "), _c('hr', {
    staticClass: "hidden-sm-and-up"
  })]), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm5": ""
    }
  }, [_c('div', {
    staticClass: "ma-4",
    staticStyle: {
      "min-height": "9em"
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Step 3 挑戰任務")]), _vm._v(" "), _c('p', [_vm._v("課程中安排了許多英語學習任務，透過 GPS 定位及 AR 擴增實境，解鎖景點，從生活場域中發現你所看的聽的都是英文，答對了可立即獲得獎勵金幣。")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "ma-4 pb-4",
    staticStyle: {
      "min-height": "9em"
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Step 4 兌換好禮")]), _vm._v(" "), _c('p', [_vm._v("獎勵金幣達指定數量時，即有機會兌換 LiveABC 提供的學習禮物，實際兌換禮物依網站公告為準。")])])])], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "pa-5",
    attrs: {
      "id": "anchor-4"
    }
  }, [_c('h4', {
    staticClass: "primary-color title"
  }, [_vm._v("購買方案")]), _vm._v(" "), _c('p', {
    staticClass: "primary-color desc"
  }, [_vm._v("選擇適合您的旅遊學習方式，跟著我們走到哪學到哪。")]), _vm._v(" "), _c('v-row', {
    staticClass: "ma-3 mt-5 text-xs-center average"
  }, [_c('v-col', {
    staticClass: "ma-3 pa-5 bg--light",
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("悠活30方案")]), _c('br'), _vm._v("\n        30天"), _c('br'), _vm._v(" 定價 "), _c('span', {
    staticStyle: {
      "text-decoration": "line-through"
    }
  }, [_vm._v("300元")]), _vm._v(" / 特價 "), _c('span', {
    staticStyle: {
      "font-size": "1.3em"
    }
  }, [_vm._v("60")]), _vm._v("元"), _c('br')]), _vm._v(" "), _c('v-col', {
    staticClass: "ma-3 pa-5 bg--light",
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("暢遊365方案")]), _c('br'), _vm._v("\n        365天"), _c('br'), _vm._v(" 定價 "), _c('span', {
    staticStyle: {
      "text-decoration": "line-through"
    }
  }, [_vm._v("900元")]), _vm._v(" / 特價 "), _c('span', {
    staticStyle: {
      "font-size": "1.3em"
    }
  }, [_vm._v("300")]), _vm._v("元"), _c('br')])], 1), _vm._v(" "), _c('p', {
    staticClass: "primary-color mt-5"
  }, [_vm._v("小編提醒：建議搭配4G行動上網方案體驗「遊臺中學英語」景點課程，確保學習服務順暢。")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ebb2fc5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 629
// module chunks = 1